import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Map, List } from 'immutable'
import getCSRFToken from '@aytm/lib/csrf-token'
import railsPostFetch from '@aytm/lib/common/rails-post-fetch'

import { PureDataComponent } from '@aytm/lib/common/components/pure-component'
import { SwidgetImage, SwidgetPinImage } from '@aytm/app/swidget/questions/components/common/swidget-image'
import { RTL_LOCALES, isRTL } from '@aytm/app/swidget/questions/lib/functions'
import questionsLocale from '@aytm/app/swidget/questions/locale'

// styles
import style from '@aytm/app/swidget/questions/styles/_base.module.scss'
import commonStyle from '@aytm/app/swidget/questions/styles/common.module.scss'

//export default class Question extends Component {
class QuestionTheme extends PureDataComponent {
  static propTypes = {
    accentColorRGB: PropTypes.object,
    accentColor: PropTypes.string,
    columns: PropTypes.number
  }
  render() {
    const accentColor = this.props.accentColor

    this.currentAccentColor = accentColor

    if (!this.props.accentColor) return null
    return (
      <style
        type="text/css"
        dangerouslySetInnerHTML={{
          __html: `
          .rfd-ui-popup .rfd-ui-popup-content.rfd-ui-popup-content-thin-black {
            background: ${accentColor};
          }
          .rfd-ui-popup .rfd-ui-popup-arrow.rfd-ui-popup-arrow-right {
            border-color: transparent transparent transparent ${accentColor};
            filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.2));
          }
          .rfd-ui-popup .rfd-ui-popup-arrow.rfd-ui-popup-arrow-bottom {
            border-color: ${accentColor} transparent transparent transparent;
            filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.2));
          }`
        }}
      />
    )
  }
}

export default class Question extends PureDataComponent {
  static propTypes = {
    questionSchema: PropTypes.instanceOf(Map).isRequired,
    answer: PropTypes.instanceOf(Map),
    theme: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    inFrame: PropTypes.bool,
    part: PropTypes.number,
    locale: PropTypes.string,
    showErrors: PropTypes.bool,
    accentColorRGB: PropTypes.object,
    accentColor: PropTypes.string,
    position: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    imageCallback: PropTypes.func,
    sizeChanged: PropTypes.func,
    actionAfterDidMount: PropTypes.func,
    goNext: PropTypes.func,
    onLogEvent: PropTypes.func,
    answerChanged: PropTypes.func
  }

  constructor(props) {
    super(props)
    this.resizeForFrame = this.resizeForFrame.bind(this)
    this.updateAnswer = this.updateAnswer.bind(this)
    this.initAnswer = this.initAnswer.bind(this)
    this.initTimeline = this.initTimeline.bind(this)
    this.updateTimeline = this.updateTimeline.bind(this)
    this.sendDebugLog = this.sendDebugLog.bind(this)
    this.sendSurveyLogs = this.sendSurveyLogs.bind(this)
    this.resizeText = this.resizeText.bind(this)
    this.getMinimumResizedStyle = this.getMinimumResizedStyle.bind(this)
    this.rootEl = React.createRef()
    this.isPincherActive = 'ontouchstart' in document.documentElement
    // Localized fallback for images with no authored alt text (mirrors swidget base ImageAsset).
    this.noAltText = questionsLocale(props.locale).getIn(['questions', 'noAlt'])
    this.state = {
      answer: props.answer || null,
      imagesLoaded: List([]),
      imagesFailed: List([]),
      timeline: []
    }
    this.initTimeline()
    this.loadBigImages(props)
    this.waitForSmallImages(props)
  }

  componentDidMount() {
    super.componentDidMount()
    if ('function' === typeof this.props.actionResize) this.props.actionResize()
    if ('function' === typeof this.props.actionAfterDidMount) this.props.actionAfterDidMount()

    // set focus to the top of the question on question change
    const progressBar = document.querySelector('#survey-pb-progressbar [tabindex]')
    if (progressBar) {
      progressBar.focus()
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    super.UNSAFE_componentWillReceiveProps(nextProps)
    if (nextProps.answer != this.props.answer && nextProps.answer != this.state.answer) {
      const validation = this.validate(nextProps.answer)
      this.setState({ answer: nextProps.answer, validation })
    }
    if (nextProps.pair != this.props.pair) {
      this.setState({ imagesLoaded: List([]) })
      this.loadBigImages(nextProps)
    }
    if (nextProps.questionSchema != this.props.questionSchema) {
      this.loadBigImages(nextProps)
      this.waitForSmallImages(nextProps)
    }
  }

  loadBigImages(props) {
    if ('im' == props.questionSchema.get('type') || this.isPincherActive)
      this.preLoadImage(props.questionSchema, 'original_url')
    this.preLoadImage(props.questionSchema, 'big_thumbnail_path')
    this.preLoadQuestionImages(props)
  }

  waitForSmallImages(props) {
    const paths = List(
      props.questionSchema.getIn(['picture', 'original_url']) && !props.questionSchema.getIn(['picture', 'pin_image'])
        ? [props.questionSchema.getIn(['picture', 'thumbnail_path'])]
        : []
    ).concat(this.collectSmallImages(props))

    Promise.all(
      paths.map(
        path =>
          new Promise(resolve => {
            if (!path) resolve()
            if (path) {
              const img = new Image()
              img.onload = () => resolve({ path })

              img.onerror = () => resolve({ path })
              img.src = path
            }
          })
      )
    ).then(() => {
      setTimeout(() => {
        this.setState({ smallImagesReady: true })
        if ('function' === typeof props.afterImage) props.afterImage()
      }, 10)
    })
  }

  collectSmallImages(__props) {
    return List([])
  }

  preLoadQuestionImages(__props) {
    return false
  }

  preLoadImage(item, path) {
    if (item.get('picture') && item.getIn(['picture', path])) {
      this.loadImage(item.getIn(['picture', path]))
        .then(url => {
          this.setState({ imagesLoaded: this.state.imagesLoaded.push(url) })
          if ('function' === typeof this.props.afterImage) this.props.afterImage()
        })
        .catch(error => this.setState({ imagesFailed: this.state.imagesFailed.push(error) }))
    }
    // if (item.get('image') && item.getIn(['image', path])) {
    //   this.loadImage(item.getIn(['image', path]))
    //     .then(url => {
    //       this.setState({ imagesLoaded: this.state.imagesLoaded.push(url) })
    //       if ('function' === typeof this.props.afterImage) this.props.afterImage()
    //     })
    //     .catch(error => this.setState({ imagesFailed: this.state.imagesFailed.push(error) }))
    // }
  }

  async loadImage(url) {
    return new Promise((resolve, reject) => {
      const img = new Image()
      img.addEventListener('load', () => resolve(url))
      img.addEventListener('error', () => {
        reject(new Error(url))
      })
      img.src = url
    })
  }

  resizeForFrame() {
    if (this.props.inFrame && 'function' === typeof this.props.actionResize) this.props.actionResize()
  }

  updateAnswer(answerModel = null, timeline = null) {
    const { answerChanged, answer } = this.props
    if (answerModel !== this.state.answer || answerModel !== answer) {
      const validation = this.validate(answerModel)
      const response = this.backendResponse(answerModel)
      response.timeline = timeline || this.state.timeline
      this.setState({ answer: answerModel, validation })
      if ('function' === typeof answerChanged) answerChanged(answerModel, validation, response)
    }
  }

  initAnswer(answerModel, force) {
    const { answerChanged } = this.props
    const validation = this.validate(answerModel)
    const response = this.backendResponse(answerModel)
    if (!this.state.answer || force) {
      this.state.answer = answerModel
    }
    if ('function' === typeof answerChanged) answerChanged(answerModel, validation, response)
  }

  initTimeline() {
    this.state.timeline = []
    this.startTime = Date.now()
  }

  updateTimeline(event, oldTimeline) {
    const timeline = oldTimeline || this.state.timeline
    const { onLogEvent } = this.props
    if (timeline) {
      const time = Date.now()
      const timeDif = Math.round((time - this.startTime) / 10) / 100
      timeline.push({ ...event, time: timeDif })
      this.setState({ timeline })
    }
    if (onLogEvent && 'function' == typeof onLogEvent) onLogEvent(event)
    return timeline
  }

  sendDebugLog(log, message = 'Swidget Question Log') {
    if (log && log.length) {
      // eslint-disable-next-line no-console
      //console.log(log, 'this.debugLog')
      // eslint-disable-next-line unicorn/no-lonely-if
      if (window.Sentry && window.Sentry.withScope) {
        window.Sentry.withScope(function (scope) {
          scope.setLevel('log')
          scope.setExtra('details', log)
          window.Sentry.captureMessage(message)
        })
      }
    }
  }

  sendSurveyLogs(url, params, log = {}) {
    // data should contain { proxy_params: this._options.action.proxyParams }
    if (url && params && log) {
      const data = {}
      const csrfToken = getCSRFToken()
      data[csrfToken[0]] = csrfToken[1]
      for (const key in params) {
        data[key] = params[key]
      }
      for (const key in log) {
        data[key] = log[key]
      }
      railsPostFetch(url, {
        body: JSON.stringify(data),
        mode: 'cors'
      }).catch(error => {
        console.log(error) // eslint-disable-line no-console
      })
    }
  }

  resizeText(text, width, height, options = {}) {
    const isMobile = 'mobile' == this.props.theme
    const h = document.querySelector('body')
    const d = document.createElement('div')
    const s = document.createElement('span')
    let it = Math.min(height, 100)
    d.style.display = 'block'
    d.style.width = width - 5 + 'px'
    d.style.height = height - 5 + 'px'
    d.style.fontSize = it + 'px'
    d.style.whiteSpace = 'normal'
    d.style.lineHeight = it + 'px'
    // eslint-disable-next-line unicorn/prefer-dom-node-append
    h.appendChild(d)
    s.style.display = 'inline'
    s.style.fontSize = it + 'px'
    s.style.fontFamily = 'Ubuntu, Calibri, Segoe, Helvetica, Arial'
    s.style.lineHeight = it + 'px'
    s.innerHTML = text
    // eslint-disable-next-line unicorn/prefer-dom-node-append
    d.appendChild(s)

    let sw = s.offsetWidth
    let sh = s.offsetHeight

    const widthOffset = options && options.widthOffset ? options.widthOffset : 25
    const heightOffset = options && options.heightOffset ? options.heightOffset : isMobile ? 10 : 25
    const minFontSize = options && options.minFontSize ? options.minFontSize : 15

    while ((sw > width - widthOffset || sh > height - heightOffset) && it > minFontSize) {
      it -= Math.ceil(sw / (width - 5))
      d.style.fontSize = it + 'px'
      d.style.lineHeight = it + 'px'
      s.style.fontSize = it + 'px'
      s.style.lineHeight = it + 'px'
      sw = s.offsetWidth
      sh = s.offsetHeight
    }

    // eslint-disable-next-line unicorn/prefer-dom-node-remove
    h.removeChild(d)
    return {
      fontSize: it + 'px',
      lineHeight: it + 'px'
    }
  }

  getMinimumResizedStyle(items, width, height) {
    return items.reduce((res, item) => {
      const fontStyleItem = this.resizeText(item.get('text'), width, height)
      return !res.fontSize ||
        parseInt(fontStyleItem.fontSize.split('px')[0], 10) < parseInt(res.fontSize.split('px')[0], 10)
        ? fontStyleItem
        : res
    }, {})
  }

  validate(_answer) {
    return Map({ valid: true, canAdvance: false })
  }

  backendResponse(answer) {
    return answer
  }

  renderDesktop() {
    return null
  }

  renderMobile() {
    return null
  }

  render() {
    const {
      theme,
      width,
      position,
      questionSchema,
      inFrame,
      imageCallback,
      accentColor,
      accentColorRGB,
      locale,
      noHeader
    } = this.props
    const { imagesLoaded, smallImagesReady } = this.state
    const expandImages = questionSchema.get('expand_all_images') && questionSchema.get('id')
    const picture = questionSchema.get('picture')
    const skipIcon = questionSchema.get('skipIcon')
    const skipHtml = questionSchema.get('skipHtml')

    const showHeaderPic = questionSchema.get('skipPic')
      ? !questionSchema.get('skipPic')
      : questionSchema.get('type') != 'im' && questionSchema.get('type') != 'sft'

    let label = position ? position + '. ' : ''
    if (0 === (questionSchema.get('text') || '').length && 'number' === typeof position) {
      label = ''
    }

    const rtlStyle =
      (isRTL(questionSchema.get('text') || '') || 'sft' === questionSchema.get('type')) && RTL_LOCALES.includes(locale)

    return (
      <Fragment>
        {smallImagesReady ? (
          <Fragment>
            {noHeader ? (
              <></>
            ) : (
              <Fragment key="header">
                <QuestionTheme accentColor={accentColor} accentColorRGB={accentColorRGB} />
                <div className={`${style.header} ${style[theme]}` + (rtlStyle ? ` ${style.rtl}` : ``)}>
                  {skipHtml && (
                    <div className={`${commonStyle.hint} ${commonStyle['hint-skip']}`}>
                      <i className={`${commonStyle['hint-icon']} ${skipIcon}`} />
                      <div dangerouslySetInnerHTML={{ __html: skipHtml }} />
                    </div>
                  )}
                  {showHeaderPic &&
                    picture &&
                    picture.get('original_url') &&
                    !picture.get('pin_image') &&
                    !expandImages && (
                      <SwidgetImage
                        text={(questionSchema.get('text') || '').replace('<br/><br/>', '<br/>')}
                        picture={picture}
                        accentColor={accentColor}
                        theme={theme}
                        inFrame={inFrame}
                        imageCallback={imageCallback}
                        noAltText={this.noAltText}
                      />
                    )}
                  <span className={style.span}>
                    {rtlStyle ? (
                      <h2
                        className={style.title}
                        id="swidget-question-header-text"
                        style={{ maxWidth: width ? width - 30 : 'auto' }}
                      >
                        <span>{label}</span>
                        <span
                          className={style.titleSpan}
                          dangerouslySetInnerHTML={{
                            __html: questionSchema.get('text') || questionSchema.get('question_text') || ''
                          }}
                        />
                      </h2>
                    ) : (
                      <h2
                        className={style.title}
                        id="swidget-question-header-text"
                        dangerouslySetInnerHTML={{
                          __html: label + ' ' + (questionSchema.get('text') || '')
                        }}
                        style={{ maxWidth: width ? width - 30 : 'auto' }}
                      />
                    )}
                  </span>
                </div>
              </Fragment>
            )}
            <div className="sq_content" key="content">
              <div
                ref={this.rootEl}
                className={`${style.content} ${style[theme]}` + (rtlStyle ? ` ${style.rtlContent}` : ``)}
                style={{ width: width ? width : 'auto' }}
              >
                {showHeaderPic &&
                  picture &&
                  picture.get('original_url') &&
                  (expandImages || picture.get('pin_image')) && (
                    <div className={style.questionImage}>
                      <SwidgetPinImage
                        picture={picture.set('pin_image', true)}
                        onLoad={this.resizeForFrame}
                        imageCallback={imageCallback}
                        accentColor={accentColor}
                        text={(questionSchema.get('text') || '').replace('<br/><br/>', '<br/>')}
                        noAltText={this.noAltText}
                        hasLoaded={imagesLoaded.includes(
                          picture.get(this.isPincherActive ? 'original_url' : 'big_thumbnail_path')
                        )}
                      />
                    </div>
                  )}
                {(() => {
                  switch (theme) {
                    case 'mobile':
                      return this.renderMobile()
                    default:
                      // 'desktop'
                      return this.renderDesktop()
                  }
                })()}
              </div>
            </div>
          </Fragment>
        ) : (
          <div className="preloaderDiv">
            <div className={style.preloader}></div>
          </div>
        )}
      </Fragment>
    )
  }
}
